import React from "react";
import styles from "./NewPost.module.sass";
import cn from "classnames";
import Icon from "../../../../components/Icon";

const items = [
    {
        avatar: "/images/content/avatar.jpg",
        icon: "profile-circle",
    },
    {
        avatar: "/images/content/avatar-1.jpg",
        icon: "lock",
    },
];

const files = [
    "lock",
];

const NewPost = () => {
    return (
        <div className={styles.post}>
            <div className={cn("title-green", styles.title)}>
                Modal Example
            </div>
            <div className={styles.list}>
                {items.map((x, index) => (
                    <div className={styles.avatar} key={index}>
                        <img src={x.avatar} alt="Avatar" />
                        <div className={styles.social}>
                            <Icon name={x.icon} size="12" />
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles.field}>
                <input
                    className={styles.textarea}
                    name="post"
                    placeholder="Value Input"
                />
            </div>
            <div className={styles.info}>
                Description of the transaction{" "}
                <span role="img" aria-label="fire">
                    🔥
                </span>
            </div>
            <div className={styles.foot}>
                <div className={styles.files}>
                    {files.map((x, index) => (
                        <div className={styles.file} key={index}>
                            <div className={styles.icon}>
                                <Icon name={x} size="20" />
                            </div>
                        </div>
                    ))}
                </div>
                <button className={cn("button", styles.button)}>
                    <span>Confirm Transaction</span>
                    <Icon name="arrow-right" size="24" />
                </button>
            </div>
        </div>
    );
};

export default NewPost;
